<template>
  <div>
    <v-dialog v-model="showModal" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="$emit('close-modal-email-configuration')">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Email settings</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click="showModalCreateTemplate = true; isDefault = false">Add Template</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-tabs color="blue lighten-4" slider-color="black" v-model="active">
          <v-tab ripple key="1">Sender</v-tab>
          <v-tab ripple key="2">Reminder</v-tab>
          <v-tab-item>

            <v-flex xs12 md6 class="justify-center">
              <v-autocomplete
                v-if="templateSenderSelected"
                v-model="round.template_sender"
                :items="templatesSender"
                :search-input.sync="searchSender"
                color="white"
                hide-no-data
                hide-selected
                item-text="name"
                item-value="id"
                label="Sender's Templates"
                placeholder="Start typing to Search"
                @change="updateTemplateSender()"
                class="ml-3 mt-4"
              ></v-autocomplete>
            </v-flex>

            <!--
            <v-radio-group v-model="round.template_sender" row @change="updateTemplateSender()" class="ml-3">
              <v-radio
                v-for="template in templatesSender"
                :key="template.id"
                :label="template.name"
                :value="template.id"
              ></v-radio>
            </v-radio-group>
            -->
            <show-template
              v-if="templateSenderSelected"
              :templateId="templateSenderSelected.id"
              :roundId="round.id"
              @open-modal-create-template="openModalCreateTemplate"
            ></show-template>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-flex xs12 md6 class="justify-center">
                <v-autocomplete
                  v-if="templateReminderSelected"
                  v-model="round.template_reminder"
                  :items="templatesReminder"
                  :search-input.sync="searchReminder"
                  color="white"
                  hide-no-data
                  hide-selected
                  item-text="name"
                  item-value="id"
                  label="Reminders's Templates"
                  placeholder="Start typing to Search"
                  @change="updateTemplateReminder()"
                  class="ml-3 mt-4"
                ></v-autocomplete>
              </v-flex>
              <!--
              <v-radio-group
                v-model="round.template_reminder"
                row @change="updateTemplateReminder()"
                style="padding-left:5px;"
              >
                <v-radio
                  v-for="template in templatesReminder"
                  :key="template.id"
                  :label="template.name"
                  :value="template.id"
                ></v-radio>
              </v-radio-group>
              -->
              <show-template
                v-if="templateReminderSelected"
                :templateId="templateReminderSelected.id"
                :roundId="round.id"
                @open-modal-create-template="openModalCreateTemplate"
              ></show-template>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-card>
      <modal-create-template
        :show="showModalCreateTemplate"
        :template-type="active"
        :is-default="isDefault"
        @close-modal-create-template="showModalCreateTemplate=false"
        @add-template="addTemplate"
      ></modal-create-template>
    </v-dialog>
  </div>
</template>
<script>
import lodash from 'lodash';
import { mapGetters, mapActions } from 'vuex';
import ShowTemplate from '@/components/client/templates/Show.vue';
import ModalCreateTemplate from '@/components/client/templates/modals/Create.vue';
export default {
  components: {
    ShowTemplate,
    ModalCreateTemplate
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    round: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      active: '0',
      showModalCreateTemplate: false,
      templatesSender: [],
      templatesReminder: [],
      isDefault: false,
      model: null,
      searchSender: null,
      searchReminder: null
    };
  },
  computed: {
    templateSenderSelected: function () {
      if (this.round.template_sender === null) {
        return this.templatesSender[this.templatesSender.length - 1];
      }
      return this.templatesSender.find(template => template.id === this.round.template_sender);
    },
    templateReminderSelected: function () {
      if (this.round.template_reminder === null) {
        return this.templatesReminder[this.templatesReminder.length - 1];
      }
      return this.templatesReminder.find(template => template.id === this.round.template_reminder);
    }   
  },
  mounted () {
    this.getTemplates();
  },
  methods: {
    ...mapActions(['setSnackbar', 'setLoading']),
    getTemplates () {
      const url = `templates`;
      this.setLoading(true);
      window.axios.get(url).then(response => {
        this.setLoading(false);
        this.templatesSender = response.data.data.filter(template => template.type === 'sender');
        this.templatesReminder = response.data.data.filter(template => template.type === 'reminder');
        /* Associate Default Value for template but no save */
        if (this.round.template_sender === null) {
          this.round.template_sender = this.templatesSender[this.templatesSender.length - 1].id;
        }
        if (this.round.template_reminder === null) {
          this.round.template_reminder = this.templatesReminder[this.templatesReminder.length - 1].id;
        }
      }).catch(error => {
        this.setSnackbar({
          show: true,
          color: 'red',
          text: 'Get Templates Error!'
        });
        this.setLoading(false);
      });
    },
    addTemplate (template) {
      if (template.type === 'reminder') {
        this.templatesReminder.unshift(template);
        this.round.template_reminder = template.id;
        this.updateTemplateReminder();
      } else {
        this.templatesSender.unshift(template); 
        this.round.template_sender = template.id;
        this.updateTemplateSender();
      }
      this.showModalCreateTemplate = false;
    },
    openModalConfirmChanges () {
      this.$store.dispatch('setTemplateModalConfirmChanges', true);
    },
    updateTemplateSender () {
      const url = `rounds/${this.round.id}/update-template/sender`;
      let payload = {
        'template_id': this.templateSenderSelected.id,
        'round_id': this.round.id,
        'type': this.templateSenderSelected.type,
        'default': this.templateSenderSelected.default,
        'client_id': this.templateSenderSelected.client_id,
      };
      window.axios.put(url, payload).then(response => {});
    },
    updateTemplateReminder () {
      const url = `rounds/${this.round.id}/update-template/reminder`;
      let payload = {
        'template_id': this.templateReminderSelected.id,
        'round_id': this.round.id,
        'type': this.templateReminderSelected.type,
        'default': this.templateReminderSelected.default,
        'client_id': this.templateReminderSelected.client_id
      };
      window.axios.put(url, payload).then(response => {});
    },
    openModalCreateTemplate () {
      this.showModalCreateTemplate = true;
      this.isDefault = true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/client/rounds/modals/EmailConfiguration.vue